import React, { ReactNode } from "react";
import "./NoResultsScreen.scss";
import classNames from "classnames";

interface NoResultsProps {
  title: ReactNode;
  subtitle: ReactNode;
  imgUrl?: string;
  bottomContent?: ReactNode;
  mode?: "vertical" | "horizontal";
}

function NoResults({
  title,
  subtitle,
  imgUrl,
  bottomContent,
  mode = "horizontal",
}: NoResultsProps) {
  return (
    <div
      className={classNames("no-results-screen", {
        "no-results-screen--vertical": mode === "vertical",
      })}
    >
      <div className="no-results-screen__content">
        <h2 className="no-results-screen__title">{title}</h2>
        {subtitle && (
          <div>
            <p className="no-results-screen__subtitle">{subtitle}</p>
          </div>
        )}
        {bottomContent && (
          <div className="no-results-screen__bottom-content">
            {bottomContent}
          </div>
        )}
      </div>
      {imgUrl && (
        <div className="no-results-screen__img-wrapper">
          <img src={imgUrl} className="no-results-screen__img" />
        </div>
      )}
    </div>
  );
}

export default NoResults;
